var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"status-wrapper"},_vm._l((_vm.buttons),function(btn,index){return _c('button',{key:index,style:({ 
            backgroundColor: btn.is_active || index === _vm.hoveredBtn ? btn.color : '#8e8e8e',
            'border-top-left-radius': index == 0 ? '.3em' : null,
            'border-bottom-left-radius': index == 0 ? '.3em' : null,
            'border-top-right-radius': index == _vm.buttons.length-1 ? '.3em' : null,
            'border-bottom-right-radius': index == _vm.buttons.length-1 ? '.3em' : null,
            'border-left': index != 0 && index != _vm.buttons.length ? 'thin solid lightgray' : null,
            'border-right': index != 0 && index != _vm.buttons.length ? 'thin solid lightgray' : null,
        }),on:{"click":() => btn.callback(),"mouseover":function($event){return _vm.handleHover(index)},"mouseleave":function($event){return _vm.handleHover(null)}}},[_vm._v("\n        "+_vm._s(btn.text)+"\n    ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }